export function getLazyEditor() {
    return import("./view").then((module) => module.default);
}

export default function getEditor(settings) {
    return import("./view").then((module) => module.default(settings || {}));
}
